import { render, staticRenderFns } from "./BookingInfoStep.vue?vue&type=template&id=646bf44e&scoped=true"
import script from "./BookingInfoStep.vue?vue&type=script&lang=js"
export * from "./BookingInfoStep.vue?vue&type=script&lang=js"
import style0 from "./BookingInfoStep.vue?vue&type=style&index=0&id=646bf44e&prod&scoped=true&lang=css"
import style1 from "./BookingInfoStep.vue?vue&type=style&index=1&id=646bf44e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646bf44e",
  null
  
)

export default component.exports